import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as correctiveActionTypesServiceClear } from './correctiveActionTypesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'correctiveActionTypes',
  serviceTableName: 'correctiveActionTypesService',
  serviceClearFunction: correctiveActionTypesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.proposedCorrectiveAction]),
});
